import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../constant';
import { useAuth } from './AuthProvider';
import { deriveRole } from './deriveRole';

/**
 * Signed in, but the saved role is missing or not a panel role. Redirecting to
 * /login would bounce straight back to `/` (the sign-in page sends signed-in
 * users home), so look the role up once instead.
 */
const RecoverRole = () => {
    const { token, setToken, setRole } = useAuth();
    const [state, setState] = useState<'loading' | 'none' | 'error'>('loading');

    useEffect(() => {
        let alive = true;
        API.get('api/user-info/', { headers: { Authorization: `Bearer ${token}` } })
            .then((res: any) => {
                if (!alive) return;
                const role = deriveRole(res?.data);
                if (role) setRole(role as any);
                else setState('none');
            })
            .catch((err: any) => {
                if (!alive) return;
                if (err?.response?.status === 401) setToken(null);
                else setState('error');
            });
        return () => { alive = false; };
    }, [token, setToken, setRole]);

    if (state === 'loading') {
        return <p role="status" className="p-6 text-sm text-muted">Loading your account…</p>;
    }
    return (
        <div role="alert" className="mx-auto mt-16 max-w-md rounded-[18px] border border-line bg-surface p-6 text-center shadow-card">
            <p className="font-display text-[17px] font-bold text-ink">
                {state === 'none' ? "This account can't use the school panel." : "We couldn't load your account."}
            </p>
            <p className="mt-1.5 text-sm text-muted">
                {state === 'none' ? 'Sign in with a staff account.' : 'Check your connection and reload the page.'}
            </p>
            <Link to="/logout" className="mt-4 inline-flex min-h-[40px] items-center rounded-[12px] bg-navy px-4 text-sm font-semibold text-white hover:bg-navy-2">
                Sign out
            </Link>
        </div>
    );
};

export default RecoverRole;
